import React from 'react'

import {
  combine,
  withState,
  withCallback,
  withCallbacks,
} from 'react-hooks-combine'

import PopupComponent from './component'

export default combine(
  withState('isOpen', 'openPopup', false),
  withCallback(
    'onMouseEnter',
    ({ openPopup }) =>
      () => {
        openPopup(true)
      },
    []
  ),
  withCallbacks(
    {
      onMouseLeave:
        ({ openPopup }) =>
        () => {
          openPopup(false)
        },

      renderTrigger:
        ({ isOpen, onMouseEnter }, { trigger }) =>
        () => {
          const props = { onMouseEnter }

          if (typeof trigger === 'function') {
            return React.cloneElement(trigger(isOpen), props)
          }

          return React.cloneElement(trigger, props)
        },
    },
    ['isOpen']
  )
)(PopupComponent)
